import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ServerContext {
  tenantId: string;
}

@Injectable({ providedIn: 'root' })
export class ServerContextService {
  private readonly storageKey = 'vault_server_context';
  private readonly contextSubject = new BehaviorSubject<ServerContext>(this.readContext());

  readonly context$ = this.contextSubject.asObservable();

  getContext(): ServerContext {
    return this.contextSubject.value;
  }

  setContext(partial: Partial<ServerContext>): void {
    const next: ServerContext = {
      tenantId: (partial.tenantId ?? '').trim(),
    };
    localStorage.setItem(this.storageKey, JSON.stringify(next));
    this.contextSubject.next(next);
  }

  clearContext(): void {
    localStorage.removeItem(this.storageKey);
    this.contextSubject.next(this.emptyContext());
  }

  private readContext(): ServerContext {
    const raw = localStorage.getItem(this.storageKey);
    if (!raw) return this.emptyContext();
    try {
      const parsed = JSON.parse(raw) as Partial<ServerContext>;
      return {
        tenantId: (parsed.tenantId ?? '').trim(),
      };
    } catch {
      return this.emptyContext();
    }
  }

  private emptyContext(): ServerContext {
    return {
      tenantId: '',
    };
  }
}
